import axios from "axios";
import { SettingLimitResponse } from "./dtos/account.dto";
import { SettingUpdateLimit } from "@components/resolvers/setting.resolver";
import { BaseResponse } from "./dtos/base.dto";
import { BaseService } from "./base.service";

interface AccountServiceInterface {
  queries: {
    GET_SETTING_LIMIT: string;
  };
  settingLimit(nis: string): Promise<SettingLimitResponse>;
  updateSettingLimit(
    payload: SettingUpdateLimit,
  ): Promise<BaseResponse<boolean>>;
  updateTokenFirebase(token: string): Promise<BaseResponse<boolean>>;
}
export const AccountService: AccountServiceInterface = {
  queries: {
    GET_SETTING_LIMIT: "GET_SETTING_LIMIT",
  },

  settingLimit: async (nis: string) => {
    try {
      const request = await axios.get(
        `https://dehaotapi.sipond.id/api/keuangan/limit/${nis}`,
        {
          headers: {
            token:
              "$2y$12$.ztMaYznNLvwXEBgQ6G.TunKw/ONAj9uTnCmBdsnnDXOkzikQxxBG",
          },
        },
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data,
      };
    } catch (error: any) {
      return {
        success: false,
        message: error.message,
        data: false,
      };
    }
  },

  updateSettingLimit: async (payload) => {
    try {
      const request = await axios.post(
        "https://dehaotapi.sipond.id/api/keuangan/update-limit",
        payload,
        {
          headers: {
            token:
              "$2y$12$.ztMaYznNLvwXEBgQ6G.TunKw/ONAj9uTnCmBdsnnDXOkzikQxxBG",
          },
        },
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data,
      };
    } catch (error: any) {
      return {
        success: false,
        message: error.message,
        data: false, // Return a boolean value for the data property
      };
    }
  },

  updateTokenFirebase: async (token: string) => {
    try {
      const request = await BaseService.request().post<BaseResponse<boolean>>(
        "/account/update-token-firebase",
        { token },
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
};
